import { useApp } from "../AppContext";
import { MaskLine, SectionLabel } from "./Motion";

export default function PageBanner({ label, titleObj, subObj, image }) {
  const { t } = useApp();
  return (
    <section className="relative pt-28 lg:pt-40 pb-16 lg:pb-20 overflow-hidden bg-earth-900" data-testid="page-banner">
      {image && (
        <>
          <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-35" />
          <div className="absolute inset-0 bg-gradient-to-t from-earth-900 via-earth-900/60 to-earth-900/40" />
        </>
      )}
      <div className="relative max-w-[1400px] mx-auto px-4 lg:px-8">
        {label && <SectionLabel>{label}</SectionLabel>}
        <h1 className="font-serif-head text-white text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05]">
          <MaskLine>{t(titleObj, "title")}</MaskLine>
        </h1>
        {subObj && <p className="mt-5 max-w-2xl text-sand-100/85 text-lg">{t(subObj, "intro")}</p>}
      </div>
    </section>
  );
}
